import * as Yup from 'yup';

import { resumeOptions as defaultResumeOptions } from '../../../defaultFilters';

export const useSignupHasResumeFilter = ({ setFilters }) => {
  const resumeOptions = defaultResumeOptions;

  const formSchema = Yup.object().shape({
    signupHasResume: Yup.object().shape({
      label: Yup.string().required(),
      value: Yup.string().required(),
    }),
  });

  const onSubmit = ({ signupHasResume }) => {
    setFilters({ signupHasResume });
  };

  return {
    formSchema,
    onSubmit,
    resumeOptions,
  };
};
